import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deleted-account',
  templateUrl: './deleted-account.component.html',
  styleUrls: ['./deleted-account.component.css'],
})
export class DeletedAccountComponent implements OnInit {
  constructor() {
    //Do nothing
  }

  ngOnInit(): void {
    //Do nothing
  }
}
